import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_private/dashboard/_base/conjuntos/vincular/")({
  beforeLoad: () => {
    throw redirect({ to: ".." });
  }
});
